import React, { FC, ReactNode, ReactElement } from "react";
import { Logo } from "../components/logo";
import { IntercomObserver } from "../components/observers";

type Props = {
  image?: ReactNode;
  title?: string;
  children?: ReactElement;
};

const ServicesLayout: FC<Props> = ({ image, title, children }) => {
  return (
    <div className="w-full flex flex-col items-center justify-center min-h-screen">
      <div className="flex flex-col gap-y-8 items-center">
        {image}

        <div className="max-w-[592px] text-center flex flex-col gap-y-4 md:gap-y-8 pt-6 px-8 pb-4 md:pb-16">
          {title && (
            <div className="text-4xl md:text-5xl font-poppins font-bold theme-text-default">
              {title}
            </div>
          )}
          {children}
        </div>

        <Logo
          className="justify-self-end w-32"
          align="vertical"
          width="128px"
        />
      </div>

      <IntercomObserver />
    </div>
  );
};

export default ServicesLayout;
